var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "school_qualification",
    "data-name": "school qualification",
    transform: "translate(-683 -502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 30,
    height: 30,
    transform: "translate(683 502)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "patent",
    transform: "translate(606 507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M247.586,290a2.585,2.585,0,0,0-1.791,4.45q.087.084.182.159h0q.047.037.1.073h0q.048.035.1.067l0,0q.048.031.1.061l.008,0,.1.055.012.006.1.048.017.008.095.042.023.009.092.035.029.01.088.029.036.01.084.023.044.01.078.018.053.009.072.013.063.008.064.008.079.006.051,0q.065,0,.131,0t.131,0l.051,0,.079-.006.064-.008.063-.008.072-.013.053-.009.078-.018.044-.01.084-.023.036-.01.088-.029.029-.01.092-.035.023-.009.094-.042.017-.008.1-.048.012-.006.1-.055.008,0q.05-.029.1-.061l0,0q.049-.032.1-.067h0q.049-.035.1-.073h0q.095-.075.182-.159a2.585,2.585,0,0,0-1.79-4.45Z",
    transform: "translate(-153.633 -278.461)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M98.33,0H85.6a.6.6,0,0,0-.6.6V17.508a.6.6,0,0,0,.6.6h5.372V16.45a3.739,3.739,0,0,1-.8-2.324,3.78,3.78,0,1,1,7.56,0,3.739,3.739,0,0,1-.8,2.324v1.656H98.33a.6.6,0,0,0,.6-.6V.6A.6.6,0,0,0,98.33,0ZM87.984,2.586h2.387a.6.6,0,0,1,0,1.194H87.984a.6.6,0,1,1,0-1.194Zm7.958,7.162H93.555a.6.6,0,0,1,0-1.194h2.387a.6.6,0,0,1,0,1.194Zm0-1.99H87.984a.6.6,0,1,1,0-1.194h7.958a.6.6,0,1,1,0,1.194Zm0-1.99H87.984a.6.6,0,0,1,0-1.194h7.958a.6.6,0,0,1,0,1.194Z",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M265,438.647v2.64a.6.6,0,0,0,.928.5l.863-.575.863.575a.6.6,0,0,0,.928-.5v-2.64a3.775,3.775,0,0,1-3.581,0Z",
    transform: "translate(-172.838 -421.193)",
    fill: "#3f2765"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.60ba7583cdfab96a0c9ec9e2f3345e68.svg";
export { ForwardRef as ReactComponent };